<template>
  <div>
    <vue-progress-bar></vue-progress-bar>
    <Nav />
    <div class="score mt-6">
      <span v-html="description"></span>
    </div>
    <div class="score mt-6">Total Score: {{ totalScore }}</div>
    <Flashcard :front="question" :back="answer"></Flashcard>

    <div v-if="this.$store.state.flipped && ! this.finished">
      <button class="btn btn-sure" @click="correct">小 Case 🥰</button>
      <button class="btn btn-doubt" @click="doubt">受教 🌟</button>
      <button class="btn btn-wrong" @click="wrong">错了 😥</button>
    </div>
  </div>
</template>

<script>
import Flashcard from "./Flashcard.vue";
import Nav from "./Nav.vue";
import cards from "../data/cards";

export default {
  name: "Card",
  components: {
    Flashcard,
    Nav
  },
  mounted() {
    // Added functionality
    this.$store.commit("setUnanswered", cards[this.card].data);
    this.$store.dispatch("init");
  },
  data: function() {
    return {
      totalScore: 0
    };
  },
  updated: function() {
    this.$Progress.set(this.percent);
  },
  computed: {
    card() {
      return this.$route.params.card;
    },
    question() {
      return this.$store.getters.currentQuestion; // handled by vuex
    },
    answer() {
      return this.$store.getters.currentAnswer; // handled by vuex
    },
    score() {
      return this.$store.getters.currentScore;
    },
    percent() {
      return this.$store.getters.currentPercent;
    },
    finished() {
      return this.percent >= 100;
    },
    description() {
      return cards[this.card]["description"] !== undefined
        ? cards[this.card]["description"]
        : "";
    }
  },
  methods: {
    correct() {
      if (this.finished != true) {
        this.totalScore += this.score;
        this.$store.dispatch("correctAnswer");
      }
    },
    wrong() {
      this.$store.dispatch("wrongAnswer");
    },
    doubt() {
      if (this.finished != true) {
        this.totalScore += this.score / 2;
        this.$store.dispatch("doubtAnswer");
      }
    }
  }
};
</script>

<style scoped>
#score {
  font-size: 24px;
}
.btn {
  @apply font-bold py-2 px-4 rounded mx-8;
}

.btn-sure {
  @apply bg-green-500 text-white;
}

.btn-sure:hover {
  @apply bg-green-600;
}

.btn-doubt {
  @apply bg-blue-500 text-white;
}

.btn-doubt:hover {
  @apply bg-blue-600;
}

.btn-wrong {
  @apply bg-yellow-500 text-white;
}

.btn-wrong:hover {
  @apply bg-yellow-600;
}
</style>
